/* ── External ─────────────────────────────────────────────────────────── */
import { CircleCheck, CircleX } from "lucide-react";

import { Button } from "../../../components/ui/button";

export interface AccessActionButtonsProps {
  selectedCount: number;
  onApprove: () => void;
  onDeny: () => void;
  /** "Review" on the account tables, "Approve" on the review queue. */
  approveLabel?: string;
  /** "Revoke" on the account tables, "Reject" on the review queue. */
  denyLabel?: string;
}

export function AccessActionButtons({
  selectedCount,
  onApprove,
  onDeny,
  approveLabel = "Review",
  denyLabel = "Revoke",
}: AccessActionButtonsProps) {
  const disabled = selectedCount === 0;

  return (
    <>
      <Button
        variant="approve"
        onClick={onApprove}
        disabled={disabled}
        className="justify-start gap-2 font-semibold"
      >
        <CircleCheck className="size-4" />
        {approveLabel}
      </Button>
      <Button
        variant="revoke"
        onClick={onDeny}
        disabled={disabled}
        className="justify-start gap-2 font-semibold"
      >
        <CircleX className="size-4" />
        {denyLabel}
      </Button>
    </>
  );
}
